export enum MfaMethod {
    PASSKEY = 'PASSKEY',
    AUTHENTICATOR_OTP = 'AUTHENTICATOR_OTP',
    EMAIL_OTP = 'EMAIL_OTP'
}
